import { getPimentoFailureMessage, isPimentoFailure } from "../../api/apiUtils";

/**
 * Runs a survey mutation + resink. Returns true on success (caller should close
 * the dialog); false on failure (dialog stays open; onError has been called).
 *
 * afterSuccess runs only when the mutation succeeded, and its own failure is
 * reported but does NOT flip the result — used for report generation, where a
 * failed report must not read as a failed lock.
 */
export async function confirmSurveyAction(params: {
  run: () => Promise<unknown>;
  resink: () => Promise<unknown>;
  onError: (message: string) => void;
  /** Last-resort toast when the failure has no message. Prefer ApiSurveys options.error. */
  fallback?: string;
  afterSuccess?: { run: () => Promise<unknown>; fallback?: string } | null;
}): Promise<boolean> {
  const fallback = params.fallback ?? "Request failed";
  try {
    const res = await params.run();
    if (isPimentoFailure(res)) {
      params.onError(getPimentoFailureMessage(res, fallback));
      return false;
    }
    if (params.afterSuccess) {
      const afterFallback = params.afterSuccess.fallback ?? "Request failed";
      try {
        const afterRes = await params.afterSuccess.run();
        if (isPimentoFailure(afterRes)) {
          params.onError(getPimentoFailureMessage(afterRes, afterFallback));
        }
      } catch (err) {
        params.onError(getPimentoFailureMessage(err, afterFallback));
      }
    }
    await params.resink();
    return true;
  } catch (err) {
    params.onError(getPimentoFailureMessage(err, fallback));
    return false;
  }
}
